import { SessionStorage } from '@witkac/kartamiejska-shared';

/**
 * Przekierowuje zalogowanego użytkownika na home
 *
 * @export
 * @param {(...args: any[]) => any} next
 * @returns
 */
export function redirectSignedInUser(next: (...args: any[]) => any) {
  if (localStorage.getItem(SessionStorage.TOKEN)) {
    return next({ name: 'dashboard' });
  }
  next();
}
